import React from 'react';
import { useNavigate } from 'react-router-dom';
import '@aws-amplify/ui-react/styles.css';
import { useAuthenticator } from '@aws-amplify/ui-react';
import {  signOut } from '@aws-amplify/auth';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthenticator(ctx => [ctx.user]);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-cm-bg-deep">
      <div className="w-full max-w-md p-8 space-y-8 bg-cm-bg-surface rounded-xl shadow-lg border border-cm-border-subtle">
        <div className="text-center">
          <h1 className="text-3xl font-mono font-bold text-cm-accent-orange mb-2">chronomap</h1>
        </div>

        <div className="mt-8 space-y-4">
          {user ? (
            <>
              <button
                onClick={() => navigate('/workspaces')}
                type="button"
                className="w-full text-cm-bg-deep bg-cm-accent-orange hover:opacity-90 focus:ring-4 focus:ring-cm-accent-orange/30 font-mono font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none transition-opacity"
              >
                View Workspaces
              </button>

              <button
                onClick={handleSignOut}
                type="button"
                className="w-full py-2.5 px-5 text-sm font-medium text-cm-text-secondary focus:outline-none bg-cm-bg-elevated rounded-lg border border-cm-border-subtle hover:bg-cm-bg-hover hover:text-cm-text-primary transition-colors"
              >
                Sign Out
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate('/auth/signin')}
                type="button"
                className="w-full text-cm-bg-deep bg-cm-accent-orange hover:opacity-90 focus:ring-4 focus:ring-cm-accent-orange/30 font-mono font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none transition-opacity"
              >
                Sign In
              </button>

              <button
                onClick={() => navigate('/auth/signup')}
                type="button"
                className="w-full py-2.5 px-5 text-sm font-medium text-cm-text-secondary focus:outline-none bg-cm-bg-elevated rounded-lg border border-cm-border-subtle hover:bg-cm-bg-hover hover:text-cm-text-primary transition-colors"
              >
                Sign Up
              </button>
            </>
          )}
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-cm-text-muted">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
